import {AxiosError} from "axios";
import type {UseFormReturn} from "react-hook-form";

import {
  isVehicleIdentityRequiredError,
  VEHICLE_IDENTITY_REQUIRED_MESSAGE,
} from "./vehicle-identity";
import type {VehicleFormData} from "../types";

function getValidationFieldErrors(err: AxiosError): Record<string, string[] | string> | null {
  const status = err.response?.status;
  if (status !== 422 && status !== 400) return null;
  const body = err.response?.data as {
    error_code?: string;
    errors?: Record<string, string[] | string> | string[];
  };
  if (status === 400 && body?.error_code !== "validation_failed") return null;
  const raw = body?.errors;
  if (!raw || Array.isArray(raw) || typeof raw !== "object") return null;
  return raw;
}

function getFirstMessage(value: string[] | string | undefined): string | undefined {
  if (value == null) return undefined;
  return Array.isArray(value) ? value[0] : value;
}

export function applyVehicleWriteFieldErrors(
  err: unknown,
  form: UseFormReturn<VehicleFormData>,
): void {
  if (!(err instanceof AxiosError)) return;
  const raw = getValidationFieldErrors(err);
  if (!raw) return;

  const plateMsg = getFirstMessage(raw.plate);
  const vinMsg = getFirstMessage(raw.vin);
  const combinedIdentityError = isVehicleIdentityRequiredError(plateMsg, vinMsg);

  for (const [key, msgs] of Object.entries(raw)) {
    const msg = getFirstMessage(msgs);
    if (typeof msg !== "string") continue;
    if (
      combinedIdentityError &&
      (key === "plate" || key === "vin") &&
      msg === VEHICLE_IDENTITY_REQUIRED_MESSAGE
    ) {
      form.setError(key as "plate" | "vin", {type: "identity-required", message: msg});
      continue;
    }
    if (key === "vehicle_make_id" || key === "make") {
      form.setError("make", {message: msg});
    } else if (key === "vehicle_model_id" || key === "model") {
      form.setError("model", {message: msg});
    } else if (key === "plate") {
      form.setError("plate", {message: msg});
    } else if (key === "secondary_plate") {
      form.setError("secondary_plate", {message: msg});
    } else if (key === "vin") {
      form.setError("vin", {message: msg});
    } else if (key === "state") {
      form.setError("state", {message: msg});
    } else if (key === "has_dealers_plate") {
      form.setError("has_dealers_plate", {message: msg});
    }
  }
}
